<template>
  <VerifyIdentityError
    class="md:w-480 md:mx-auto"
    :errorTitle="$t('common.no_contact_info_found')"
    :errorBody="$t('common.contact_health_plan_csr.help', [helpNumber])"
  />
</template>

<script>
import VerifyIdentityError from '../register/verify-identity/VerifyIdentityError.vue'
import supportMixin from '../../mixins/support'

export default {
  components: { VerifyIdentityError },
  mixins: [supportMixin],
  computed: {
    helpNumber() {
      return this.supportClientNumber || this.supportNumber
    },
  },
}
</script>
